module.exports = __webpack_public_path__ + "img/Kfc-logo.820ae255.png";